__turbopack_context__.v({
  "accordionSlideOverwrite": "multiSelect-module-scss-module__eK6PiG__accordionSlideOverwrite",
  "chip": "multiSelect-module-scss-module__eK6PiG__chip",
  "chipButton": "multiSelect-module-scss-module__eK6PiG__chipButton",
  "fadeIn": "multiSelect-module-scss-module__eK6PiG__fadeIn",
  "fadeOut": "multiSelect-module-scss-module__eK6PiG__fadeOut",
  "item": "multiSelect-module-scss-module__eK6PiG__item",
  "multiSelect": "multiSelect-module-scss-module__eK6PiG__multiSelect",
  "overlayChevron": "multiSelect-module-scss-module__eK6PiG__overlayChevron",
  "scaleIn": "multiSelect-module-scss-module__eK6PiG__scaleIn",
  "scaleOut": "multiSelect-module-scss-module__eK6PiG__scaleOut",
  "selectedItems": "multiSelect-module-scss-module__eK6PiG__selectedItems",
  "selectedItemsHidden": "multiSelect-module-scss-module__eK6PiG__selectedItemsHidden",
  "selectedItemsOverlay": "multiSelect-module-scss-module__eK6PiG__selectedItemsOverlay",
  "trigger": "multiSelect-module-scss-module__eK6PiG__trigger",
  "zoomIn": "multiSelect-module-scss-module__eK6PiG__zoomIn",
  "zoomOut": "multiSelect-module-scss-module__eK6PiG__zoomOut",
});
